<template>
	<div 
		id="faq-survey-form" 
		:class="['faq-survey-form', {
			active: show
		}]">
		<button 
			class="close"
			@click.stop.prevent="show=!show">
				<i class="icon-close"></i>
				<span class="screen-reader-text">Skjul</span>
			</button>
		<h2 v-if="formMessage">{{ formMessage }}</h2>
		<form 
			v-if="!complete">
			<fieldset>
				<legend>{{ data.question }}</legend>
				<div class="radio-wrapper">
					<label for="helpful-ja" class="form-control">
						<input type="radio" id="helpful-ja" :name="fieldName" value="Ja" v-model="responseText">{{ data.button_text_yes }}
					</label>
				</div>
				<div class="radio-wrapper">
					<label for="helpful-nei" class="form-control">
						<input type="radio" id="helpful-nei" :name="fieldName" value="Nei" v-model="responseText" >{{ data.button_text_no }}
					</label>
				</div>
			</fieldset>
			<button 
				type="submit" 
				:class="['dc-button', {
					loading: loading
				}]"
				@click.stop.prevent="rateTool">Send</button>
		</form>
	</div>
</template>

<script>
export default {
	props: {
		data: {
			type: Object,
			required: true,
		},
		endpoint: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			show: false,
			complete: false,
			responded: false,
			fieldName: 'helpful_rating',
			responseText: '',
			timeout: null,
			cookieName: 'nekFeedbackGiven',
		}
	},
	methods: {
		rateTool() {
			if (typeof this.responseText === '') return;
			this.loading = true;
			const endpointUrl = this.endpoint;
			const requestOptions = {
			method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ helpful_rating: this.responseText })
			};
			fetch(endpointUrl, requestOptions)
			.then(response => response.json())
			.then(data => {
				if (data.success) {
					this.complete = true;
					this.formMessage = this.data.success_message; 
					this.$cookies.set(this.cookieName, 'viewed');
				} else {
					this.formMessage = this.data.error_message;
				}
				this.loading = false;
			});
		},
		showSurvey() {
			this.show = true;
		}
	},
	mounted() {
		if (this.$cookies.get(this.cookieName)!==null) return;
		this.timeout = window.setTimeout(() => {
			this.showSurvey()
		}, this.data.delay);
	},
	beforeDestroy() {
		if (this.timeout!==null) {
			window.clearTimeout(this.timeout);
		}
	}
};
</script>
